import Loader from "./Loader";
import ImageLoader from "./ImageLoader";

const ImageGallery = {
    init(obj) {
        if (obj.hasClass('initialized')) return;
        ImageGallery.appendArrows(obj);
        ImageGallery.changeImage(obj, obj.find('.image-gallery__list-item').eq(0), true);
        ImageGallery.addEvent(obj);
        obj.addClass('initialized');
    },

    appendArrows(obj) {

        if (!obj.find('.image-gallery__list').length || obj.find('.image-gallery__list-item').length < 2) return;

        obj.find('.image-gallery__main').append(
            "<div class='image-gallery__arrow image-gallery__arrow-prev'></div>" +
            "<div class='image-gallery__arrow image-gallery__arrow-next'></div>"
        );
    },

    changeImage(obj, element, skipLoading) {
        const image = obj.find('.image-gallery__main-image');
        obj.find('.image-gallery__list-item_active').removeClass('image-gallery__list-item_active');
        if (skipLoading) {
            element.addClass('image-gallery__list-item_active');
            return;
        }
        Loader.instance(image).start();

        ImageGallery.changeInput(obj.find('[name="' + obj.data('input') + '"]'), element.data('input'));

        const src = ImageGallery.getImage(element);
        ImageLoader
            .preload(src)
            .then(() => {
                element.addClass('image-gallery__list-item_active');
                Loader.instance(image).destroy();
                ImageLoader.insert(src, image, 'background');
            }).catch((e) => console.log('Error on loading image. Image path: ' + src));

    },

    getImage(image) {
        return image.data('background');
    },

    addEvent(obj) {

        obj.find('.image-gallery__list-item').click(function () {

            if ($(this).hasClass('image-gallery__list-item_active')) return;
            ImageGallery.changeImage(obj, $(this));

        });

        obj.find('.image-gallery__arrow').click(function () {

            let iterator = 1,
                listLength = obj.find('.image-gallery__list-item').length,
                activeIndex = obj.find('.image-gallery__list-item_active').index();

            if ($(this).hasClass('image-gallery__arrow-prev')) iterator = -1;

            let targetIndex = activeIndex + iterator;
            targetIndex = targetIndex < 0 ? (listLength - 1) : (targetIndex === listLength ? 0 : targetIndex);
            ImageGallery.changeImage(obj, obj.find('.image-gallery__list-item').eq(targetIndex));

        });

    },

    changeInput(input, value) {
        if (input.length)
            input.val(value);
    }

};

export default ImageGallery;